import { ColorsSection } from "@/components/design-system/sections/branding/ColorsSection"
import { TypographySection } from "@/components/design-system/sections/branding/TypographySection"
import { ShellsSection } from "@/components/design-system/sections/structure/ShellsSection"
import { MainNavSection } from "@/components/design-system/sections/structure/MainNavSection"
import { SubNavSection } from "@/components/design-system/sections/structure/SubNavSection"
import { PageHeadersSection } from "@/components/design-system/sections/structure/PageHeadersSection"
import { BodyContentSection } from "@/components/design-system/sections/structure/BodyContentSection"
import { FootersSection } from "@/components/design-system/sections/structure/FootersSection"
import { BaseStylesSection } from "@/components/design-system/sections/base-styles/BaseStylesSection"
import { IconographySection } from "@/components/design-system/sections/elements/IconographySection"
import { ButtonsSection } from "@/components/design-system/sections/elements/ButtonsSection"
import { ButtonDropdownSection } from "@/components/design-system/sections/elements/ButtonDropdownSection"
import { FormsSection } from "@/components/design-system/sections/elements/FormsSection"
import { BadgesSection } from "@/components/design-system/sections/elements/BadgesSection"
import { ToggleButtonsSection } from "@/components/design-system/sections/elements/ToggleButtonsSection"
import { ListingsSection } from "@/components/design-system/sections/elements/ListingsSection"
import { DataTableSection } from "@/components/design-system/sections/elements/DataTableSection"
import { ModalSection } from "@/components/design-system/sections/elements/ModalSection"
import { CalloutSection } from "@/components/design-system/sections/elements/CalloutSection"
import { DropdownMenuSection } from "@/components/design-system/sections/elements/DropdownMenuSection"

export function DesignSystem() {
  return (
    <div className="mx-auto max-w-7xl space-y-12">
      <div className="max-w-2xl">
        <h1 className="text-3xl font-semibold text-ink-display">
          Design System
        </h1>
        <p className="mt-2 text-ink-muted">
          Single source of truth for every visual primitive in this app.
          Reuse what's here. Propose additions before building one-offs.
        </p>
      </div>

      <ColorsSection />
      <TypographySection />
      <ShellsSection />
      <MainNavSection />
      <SubNavSection />
      <PageHeadersSection />
      <BodyContentSection />
      <FootersSection />
      <IconographySection />
      <ButtonsSection />
      <ButtonDropdownSection />
      <FormsSection />
      <BadgesSection />
      <ToggleButtonsSection />
      <ListingsSection />
      <DataTableSection />
      <ModalSection />
      <DropdownMenuSection />
      <CalloutSection />
      <BaseStylesSection />
    </div>
  )
}

export default DesignSystem
